export enum MinimumSupportedMajorBrowserVersions {
  Chrome = 96,
  Firefox = 94,
  Opera = 80,
  Safari = 13
}
